// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"8df892cb","125":"5c20dea3","513":"e9282769","703":"fed296fa"}[chunkId] + ".chunk.js";
};